"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator")),
    _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _lodash = _interopRequireDefault(require("lodash.debounce")),
    _lodash2 = _interopRequireDefault(require("lodash.memoize")),
    _draftJs = require("draft-js"),
    _onEnterPressed = _interopRequireDefault(require("@devsta/on-enter-pressed")),
    _draftJsPluginsEditor = _interopRequireDefault(require("draft-js-plugins-editor")),
    _draftJsMentionPlugin = _interopRequireDefault(require("draft-js-mention-plugin")),
    _ExtendedRichUtils = _interopRequireDefault(require("./ExtendedRichUtils")),
    _MentionItem = _interopRequireDefault(require("./MentionItem")),
    _MentionTag = _interopRequireDefault(require("./MentionTag")),
    _positionSuggestions = _interopRequireDefault(require("../utils/positionSuggestions")),
    _getUser = _interopRequireDefault(require("../utils/getUser")),
    _StyleControls = _interopRequireDefault(require("./StyleControls"));

require("../styles/_rich-text-editor.scss");

function _createSuper(a) {
  var b = _isNativeReflectConstruct();

  return function () {
    var c,
        d = (0, _getPrototypeOf2["default"])(a);

    if (b) {
      var e = (0, _getPrototypeOf2["default"])(this).constructor;
      c = Reflect.construct(d, arguments, e);
    } else c = d.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, c);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

var ALIGNMENT_DATA_KEY = "textAlignment",
    getBlockStyle = function getBlockStyle(a) {
  var b = [];
  "blockquote" === a.getType() && b.push("rich-editor__blockquote");
  var c = a.getData().get(ALIGNMENT_DATA_KEY);
  return "right" === c ? b.push("align-right") : "center" === c ? b.push("align-center") : "left" === c ? b.push("align-left") : "justify" === c ? b.push("align-justify") : void 0, b.join(" ");
},
    RichTextEditor = function (a) {
  function b() {
    var a;
    return (0, _classCallCheck2["default"])(this, b), a = c.call(this), a.toggleBlockType = (0, _lodash2["default"])(function (b) {
      return function () {
        var c = a.props,
            d = c.editorState,
            e = c.onUpdateContent,
            f = _ExtendedRichUtils["default"].getCurrentBlockType(d);

        a.setState({
          hidePlaceholder: "unstyled" === f || b !== f
        }), e(_ExtendedRichUtils["default"].toggleBlockType(d, b));
      };
    }), a.toggleAlignment = (0, _lodash2["default"])(function (b) {
      return function () {
        var c = a.props,
            d = c.editorState,
            e = c.onUpdateContent;
        e(_ExtendedRichUtils["default"].toggleAlignment(d, b));
      };
    }), a.toggleInlineStyle = (0, _lodash2["default"])(function (b) {
      return function () {
        var c = a.props,
            d = c.editorState,
            e = c.onUpdateContent;
        e(_ExtendedRichUtils["default"].toggleInlineStyle(d, b));
      };
    }), a.onSearchChange = (0, _lodash["default"])(function () {
      var b = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function b(c) {
        var d, e, f, g, h, i, j, k, l, m;
        return _regenerator["default"].wrap(function (b) {
          for (;;) {
            switch (b.prev = b.next) {
              case 0:
                if (d = c.value, d) {
                  b.next = 3;
                  break;
                }

                return b.abrupt("return");

              case 3:
                if (e = a.props, f = e.getUsersByName, g = e.organisationId, h = a.state.cachedUsers, b.t0 = h.get(d), b.t0) {
                  b.next = 10;
                  break;
                }

                return b.next = 9, f({
                  organisationId: g,
                  name: d
                });

              case 9:
                b.t0 = b.sent;

              case 10:
                if (i = b.t0, j = i.data, k = i.error, j && !k) {
                  b.next = 15;
                  break;
                }

                return b.abrupt("return");

              case 15:
                l = j.getUsersByName, m = l.map(_getUser["default"]), h.set(d, {
                  getUsersByName: m
                }), a.setState({
                  suggestions: m
                });

              case 19:
              case "end":
                return b.stop();
            }
          }
        }, b);
      }));
      return function () {
        return b.apply(this, arguments);
      };
    }(), 250), a.onTab = function (b) {
      var c = a.props,
          d = c.editorState,
          e = c.onUpdateContent;
      e(_ExtendedRichUtils["default"].onTab(b, d, 4));
    }, a.handleKeyCommand = function (b, c) {
      var d = a.props.onUpdateContent,
          e = _ExtendedRichUtils["default"].handleKeyCommand(c, b);

      return e ? (d(e), "handled") : "non-handled";
    }, a.handleKeyPress = function (b) {
      var c = a.props.onSave,
          d = b.key,
          e = b.shiftKey;
      return c && !e && "Enter" === d ? c() : (0, _draftJs.getDefaultKeyBinding)(b);
    }, a.handleEscape = function () {
      var b = a.props.onCancel;
      return b ? void b() : void 0;
    }, a.focus = function () {
      a._editorRef && a._editorRef.focus();
    }, a.setEditorRef = function (b) {
      b && (a._editorRef = b);
    }, a.state = {
      suggestions: [],
      cachedUsers: new Map(),
      hidePlaceholder: !1
    }, a.mentionPlugin = (0, _draftJsMentionPlugin["default"])({
      mentions: [],
      positionSuggestions: _positionSuggestions["default"],
      theme: {
        mentionSuggestions: "mentions-dropdown"
      },
      mentionComponent: _MentionTag["default"]
    }), a;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      setTimeout(this.focus, 0);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._editorRef = null;
    }
  }, {
    key: "render",
    value: function render() {
      var a = this.props,
          b = a.onUpdateContent,
          c = a.editorState,
          d = a.placeholder,
          e = a.hideControls,
          f = a.disabled,
          g = a.children,
          h = a.onBlur,
          i = a.onFocus,
          j = this.state,
          k = j.suggestions,
          l = j.hidePlaceholder,
          m = this.mentionPlugin.MentionSuggestions,
          n = [this.mentionPlugin];
      return _react["default"].createElement("div", {
        className: "rich-editor"
      }, e || f ? null : _react["default"].createElement(_StyleControls["default"], {
        editorState: c,
        onToggle: this.toggleBlockType,
        onToggleInline: this.toggleInlineStyle,
        onToggleAlignment: this.toggleAlignment
      }), _react["default"].createElement("div", {
        className: (0, _classnames["default"])("rich-editor__editor", {
          "rich-editor__editor--no-controls": e || f,
          "rich-editor__editor--disabled": f
        }),
        onClick: this.focus,
        role: "textbox",
        tabIndex: 0,
        onKeyPress: (0, _onEnterPressed["default"])({
          allowPropagation: !0
        })
      }, _react["default"].createElement(_draftJsPluginsEditor["default"], {
        blockStyleFn: getBlockStyle,
        editorState: c,
        onChange: b,
        plugins: n,
        ref: this.setEditorRef,
        placeholder: l ? void 0 : d,
        keyBindingFn: this.handleKeyPress,
        onTab: this.onTab,
        onEscape: this.handleEscape,
        handleKeyCommand: this.handleKeyCommand,
        readOnly: f,
        onFocus: i,
        onBlur: h
      }), _react["default"].createElement(m, {
        onSearchChange: this.onSearchChange,
        suggestions: k,
        entryComponent: _MentionItem["default"]
      }), g));
    }
  }]), b;
}(_react.Component);

exports["default"] = RichTextEditor, RichTextEditor.defaultProps = {
  onUpdateContent: Function.prototype
};